import { ID, WoosatTelecomResponse } from '../../../../../_metronic/helpers'
import { Currency } from '../../../currency/currencies-list/core/_models'
import { RolePermission } from '../../../role-permission/roles-permissions-list/core/_models'

export type User = {
  id?: any 
  name?: string        // Field for first name
  email?: string             // Field for email
  phone?: string      // Field for phone number
  password?: string          // Field for password
  confirm_password?: string  // Field for confirm password
  roles?: any              // Field for user role
  user_name?: string         // Field for user name
  contact_details?: string   // Field for contact details
  address?: string           // Field for address
  status?: any  
  currency_preference_id?:any             // Field for active/inactive status
  currency?: Currency
}

export type UsersQueryResponse = WoosatTelecomResponse<User[]>

export const initialUser: User = {
  id: '',
  name: '',             // Default value for first name
  email: '',                  // Default value for email
  phone: '',           // Default value for phone number
  password: '',               // Default value for password
  confirm_password: '',       // Default value for confirm password
  user_name: '',              // Default value for user name
  contact_details: '',        // Default value for contact details
  address: '',                // Default value for address
  status: 1,                  // Default value set to true (active)
}
